"use strict";

define('uikit/modules/accordion',['marionette', 'backbone', '../channel', '../mixins/component.mixin', '../templates', 'semantic/modules/accordion'], function (Mn, Backbone, channel, ComponentMixin, Templates) {
  var Accordion = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui accordion',
    template: Templates.UIKit['accordion'],
    ui: {
      contents: '.content'
    },
    options: {
      inverted: false,
      styled: false,
      exclusive: true,
      animateChildren: true,
      collapsible: true,
      fluid: false
    },
    update: {
      inverted: false,
      styled: false,
      fluid: false
    },
    events: {
      'keydown > .title': 'handleKeydownToggle'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      if (!this.collection) {
        this.collection = new Backbone.Collection();
      }
    },
    updateAttributes: function updateAttributes() {
      this.addClass('styled', this.getBoolOption('styled')).addClass('fluid', this.getBoolOption('fluid')).addClass('inverted', this.getBoolOption('inverted'));
    },
    onFirstRender: function onFirstRender() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove sort reset', this._requestRender);
      }
    },
    onRender: function onRender() {
      _.each(this.ui.contents, function (content, index) {
        var model = this.collection.at(index);
        if (model.get('content')) {
          $(content).append(model.get('content'));
        } else if (model.get('view')) {
          var view = model.get('view');
          $(content).append(view.el);
          if (!view._isRendered) {
            view.render();
          }
        }
      }, this);
      this.$el.accordion(_.extend({}, this.options, {
        onChange: _.bind(this._onChange, this),
        onClose: _.bind(this._onClose, this),
        onOpen: _.bind(this.onOpen, this)
      }));
      this.$el.find('> .title').attr('tabindex', 0);
      if (this.collection) {
        this.collection.each(function (model, index) {
          if (model.get('open') === true) {
            this.$el.accordion('open', index);
          }
        }, this);
      }
    },
    add: function add(text, view, open) {
      this.collection.add({
        text: text,
        view: view,
        icon: 'dropdown',
        open: !!open
      });
      return this;
    },
    open: function open(index) {
      this.$el.accordion('open', index);
      return this;
    },
    close: function close(index) {
      this.$el.accordion('close', index);
      return this;
    },
    toggle: function toggle(index) {
      this.$el.accordion('toggle', index);
      return this;
    },
    _onChange: function _onChange() {},
    _onClose: function _onClose() {},
    onOpen: function onOpen() {},
    handleKeydownToggle: function handleKeydownToggle(ev) {
      if (ev.keyCode == 13) {
        var index = parseInt(ev.currentTarget.dataset.index);
        this.toggle(index);
      }
    }
  });
  channel.reply('accordion', function () {
    return Accordion;
  });
  return Accordion;
});

